// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton__BSmq9","skeleton-animation":"skeleton-animation__MLLYl"};